export const baseApiUrl = resolveBaseApiUrl()

function resolveBaseApiUrl() {
    switch (process.env.BRANCH) {
        case 'dev':
            return 'https://customer-service-lwvpr3pb6a-ew.a.run.app'
        default:
            return 'https://customer-service.anonymised.io'
    }
}

export const isProduction = process.env.NODE_ENV === 'production'

export const newPlatformUrl = process.env.BRANCH === 'dev' ? 'https://newplatform.dev.anonymised.io/' : 'https://newplatform.anonymised.io/'
